import React, {Component} from 'react';
import {
    View,
    Platform,
    FlatList,
} from "react-native"
import {typeExport} from "./../redux/store/type";

import {RecyclerListView} from 'recyclerlistview/web';
import EmptyView from "./empty/EmptyView";

export default class HMRecycleView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // value: 'احمد'
        }
    }


    componentWillReceiveProps(props) {


    }


    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {rowRenderer, renderFooter, columnCount, text, styleRoot, style, type, cammas, lang, linkStyle, linkText, onPressLink, HyperlinkCheck} = this.props;


        let ListCustom = Platform.OS === "web" ? RecyclerListView : FlatList;
        return (
            this.props.data?.length > 0 ?
                <ListCustom
                    {...this.props}
                    style={{flex: 1,}}
                    ListFooterComponent={renderFooter}
                    renderItem={rowRenderer}
                    removeClippedSubviews={true} // Unmount components when outside of window
                    //initialNumToRender={2} // Reduce initial render amount
                    maxToRenderPerBatch={1} // Reduce number in each render batch
                    updateCellsBatchingPeriod={100} // Increase time between renders
                    windowSize={201} // Reduce the window size
                    onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                    scrollViewProps={{
                        removeClippedSubviews: true,
                    }}
                />
                :
                <EmptyView empty={true}/>

        );
    }


}
